import '../../../assets/scss/styles-default.scss'

const TemplateDefault = ({ children }: { children: JSX.Element }) => {
  return <>{children}</>
}

export default TemplateDefault
